import {EnvironmentScenarioBase} from './EnvironmentScenarioBase';
import {HemisphereLight} from '../HemisphereLight';
import {DirectionalLight} from '../DirectionalLight';
import {Sky} from '../Sky';
import {Interval, Matm} from '../../../classes/Matm';
import {ColorInterpolation} from '../../../classes/ColorInterpolation';

declare const THREE: any;

export abstract class CommonScenario extends EnvironmentScenarioBase {

  protected hemisphereLight: HemisphereLight;
  protected dirLight: DirectionalLight;
  protected sky: Sky;

  protected skyColor = new ColorInterpolation(
    new THREE.Color(0xffffff),
    new THREE.Color(0x313131)
  );

  protected groundColors = [
    0xffffff,
    0xf9f9f9,
    0xf5f5f5,
    0xf2f2f2,
    0xf0f0f0,
    0xececec,
    0xe3e3e3,
    0xdbdbdb,
    0xbdbdbd,
    0x898989
  ];

  constructor(scene) {
    super(scene);

    this.sky = this.createSky();
    this.add(this.sky);

    const dl = new DirectionalLight();
    this.add(dl);
    this.dirLight = dl;

    this.sky.onSunPositionChange.subscribe(position => this.dirLight.position.copy(position));

    this.hemisphereLight = this.createHemisphereLight();
    this.add(this.hemisphereLight);

    const back = this.getObjectByName('back');
    back.material.color.setHex(this.skyColor.getStart());

    const ground = this.getObjectByName('ground');
    ground.material.color.setHex(this.groundColors[0]);
  }

  protected createSky(): Sky {
    return new Sky(
      {
        min: 0,
        max: 0.505
      },
      {
        min: 0.2472,
        max: 0.1745
      }
    );
  }

  protected abstract createHemisphereLight(): HemisphereLight;

  setDayLight(input: Interval) {
    const colorInterpolation = Matm.mapRange(input, {min: 0, max: 1});
    this.hemisphereLight.interpolateColor(colorInterpolation);
    this.sky.interpolate(input);
    this.dirLight.interpolateIntensity(input);
    const back = this.getObjectByName('back');
    back.material.color.copy(
      this.skyColor.interpolate(colorInterpolation)
    );
    const ground = this.getObjectByName('ground');
    ground.material.color.setHex(
      this.groundColors[input.value]
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/custom/env/scenarios/CommonScenario.ts